import { CustomerProvider, useDeviceType, Container, ErrorBoundary } from '@packages/shared';
import { SWRConfig } from 'swr';
import { AppBanner } from './AppBanner';
import { DesktopNavigation, MobileNavigation } from './Navigation';
import { Usp } from './Usp';
import { Toolbar } from './Toolbar';
import { DynamicSearchField } from './Toolbar/SearchField';
import { ArrowBox } from './Toolbar/Slots';
import { useSearchRoute } from './utils';
import { headerDefaultFetcher } from './api';

const SEARCH_ICON_MOBILE_RIGHT_POSITION = '123px';

/**
 * Integrated header module with appbanner (only mobile), toolbar and navigation.
 * This component is able to get its data whether from client or it accepts the SEO relevant initial data from server to populate SWR cache and to make its further fetches and revalidations on client.
 */
export const Header = () => {
  const { isMobile, isDesktop } = useDeviceType();

  const searchQuery = useSearchRoute();

  return (
    <SWRConfig value={{ fetcher: headerDefaultFetcher }}>
      {/* When no inner error boundary catches an error, this is the global boundary for the header. It exists only as backup. When possible, wrap every logical section with a boundary so this one will never show its fallback. */}
      <ErrorBoundary>
        <CustomerProvider>
          {isMobile && <AppBanner />}
          <Container
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              boxShadow: [1, 1, 1, 0],
              px: [0, 0, 0, 1, 0],
            }}
          >
            {!isDesktop && (
              <ErrorBoundary>
                <MobileNavigation />
              </ErrorBoundary>
            )}
            <Toolbar />
          </Container>
          {isDesktop && (
            <ErrorBoundary>
              <DesktopNavigation />
            </ErrorBoundary>
          )}
          {isDesktop && (
            <Container>
              <ErrorBoundary>
                <Usp />
              </ErrorBoundary>
            </Container>
          )}
          {/* for non-SERP routes, the SearchField is displayed via SearchSlot.tsx */}
          {/* fixed position of the arrow on top of the box */}
          {!isDesktop && searchQuery && (
            <ErrorBoundary>
              <ArrowBox left={`calc(100% - ${SEARCH_ICON_MOBILE_RIGHT_POSITION})`}>
                <DynamicSearchField />
              </ArrowBox>
            </ErrorBoundary>
          )}
        </CustomerProvider>
      </ErrorBoundary>
    </SWRConfig>
  );
};
